import { render, staticRenderFns } from "./PanelAccountSettingsCustom.vue?vue&type=template&id=1ffe0ed2&scoped=true&"
import script from "./PanelAccountSettingsCustom.vue?vue&type=script&lang=js&"
export * from "./PanelAccountSettingsCustom.vue?vue&type=script&lang=js&"
import style0 from "@melloware/coloris/dist/coloris.css?vue&type=style&index=0&lang=css&"
import style1 from "./PanelAccountSettingsCustom.vue?vue&type=style&index=1&id=1ffe0ed2&lang=css&"
import style2 from "./PanelAccountSettingsCustom.vue?vue&type=style&index=2&id=1ffe0ed2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffe0ed2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ffe0ed2')) {
      api.createRecord('1ffe0ed2', component.options)
    } else {
      api.reload('1ffe0ed2', component.options)
    }
    module.hot.accept("./PanelAccountSettingsCustom.vue?vue&type=template&id=1ffe0ed2&scoped=true&", function () {
      api.rerender('1ffe0ed2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PanelAccountSettingsCustom.vue"
export default component.exports